export const FETCH_SOFTWARE_REQUEST = 'FETCH_SOFTWARE_REQUEST'
export const FETCH_SOFTWARE_SUCCESS = 'FETCH_SOFTWARE_SUCCESS'
export const FETCH_SOFTWARE_FAILURE = 'FETCH_SOFTWARE_FAILURE'
export const FETCH_SOFTWARE_DETAILS_REQUEST = 'FETCH_SOFTWARE_DETAILS_REQUEST'
export const FETCH_SOFTWARE_DETAILS_SUCCESS = 'FETCH_SOFTWARE_DETAILS_SUCCESS'
export const FETCH_SOFTWARE_DETAILS_FAILURE = 'FETCH_SOFTWARE_DETAILS_FAILURE'
export const FETCH_SOFTWARE_TERMS_SUCCESS = 'FETCH_SOFTWARE_TERMS_SUCCESS'